document.addEventListener('DOMContentLoaded', () => {
	//console.log('AI voice landing page script file')
});
